import React from "react";
import { useDropzone } from "react-dropzone";
import CloseIcon from "@mui/icons-material/Close";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf"; // PDF icon
import DescriptionIcon from "@mui/icons-material/Description"; // File icon for Word or other files

const CDropZone = ({ onDrop, file, uploadIcon, className, onRemoveFile }) => {
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    multiple:false,
  });

  const renderFilePreview = () => {
    if (!file || !file.name) {
      return null; // Safeguard against undefined or invalid file
    }

    const fileExtension = file.name.split(".").pop().toLowerCase();

    if (["jpg", "jpeg", "png", "gif"].includes(fileExtension)) {
      // Render image preview
      return <img src={URL.createObjectURL(file)} alt="Preview" className="w-full h-full object-cover" />;
    } else if (fileExtension === "pdf") {
      // Render PDF icon
      return <PictureAsPdfIcon className="text-red-500" />;
    } else if (["doc", "docx"].includes(fileExtension)) {
      // Render Word file icon
      return <DescriptionIcon className="text-blue-500" />;
    } else {
      // Default file icon for other formats
      return <DescriptionIcon className="text-gray-500" />;
    }
  };

  return (
    <div {...getRootProps()} className={className}>
      <input {...getInputProps()} />
      {file ? (
        <div className="flex items-center text-sm leading-sm relative w-[45px] h-[45px] border border-solid border-blue-100 rounded p-2 mt-3">
          <div className="w-full h-full">{renderFilePreview()}</div>
          {/* <span>{file.name}</span> */}
          <span
            className="absolute right-[-6px] top-[-6px] w-[20px] h-[20px] rounded-full bg-blue-100 p-1 flex items-center  cursor-pointer"
            onClick={(e) => {
              e.stopPropagation(); // Prevent triggering the dropzone
              onRemoveFile(); // Call the remove handler
            }}
          >
            <CloseIcon className="!fill-blue-700 !text-sm" />
          </span>
        </div>
      ) : (
        <div className="w-auto flex items-center justify-end absolute lg:top-[12px] top-[10px] md:right-[12px] right-[16px] cursor-pointer">
          <div className="text-left">
            <p className="2xl:text-base 2xl:leading-base text-sm leading-sm font-bold text-blue-700">
              {uploadIcon}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default CDropZone;
